// extracted by mini-css-extract-plugin
export default {"idleAnimation":"Tickle-module__idleAnimation--jlmMK","runningAnimation":"Tickle-module__runningAnimation--zP268","copilotRun":"Tickle-module__copilotRun--zcx8E"};